import { getAppConfig } from '@/app/config';
import { capitalize } from '@/helpers/stringConversion';
import classes from './EnvironmentBanner.module.css';

const COMMIT_URL_BASE = 'https://github.com/20treeAI/overstory/commit/';

export const EnvironmentBanner = () => {
  const { environment } = getAppConfig();

  if (environment !== 'staging' && environment !== 'performance') {
    return null;
  }

  const sha: string | undefined = import.meta.env.VITE_GIT_COMMIT;

  return (
    <div
      data-testid="environment-banner"
      className={classes.banner}
      data-environment={environment}
    >
      <span>{`${capitalize(environment)} Environment`}</span>
      {sha && (
        <a
          className={classes.commitLink}
          href={`${COMMIT_URL_BASE}${sha}`}
          target="_blank"
          rel="noreferrer"
        >
          {sha.slice(0, 7)}
        </a>
      )}
    </div>
  );
};
